PJQ.StepIndicator = class {
    constructor($el, options = {}) {
        this.$el = $el;
        this.options = _.defaults(options, {});
        this.steps = this.options.steps ?? [];
        this.activeStep = this.options.activeStep ?? 0;
        if (_.size(this.$el) > 0) {
            this.refresh();
        }
    }

    refresh() {
        let html = '<div class="stepper-wrapper">';
        _.each(this.steps, (step, index) => {
            let statusClass = '';
            if (this.activeStep === index) {
                statusClass = 'active';
            } else if (this.activeStep > index) {
                statusClass = 'completed';
            }
            html += '<div class="stepper-item ' + statusClass + '"><div class="step-counter">' + (index + 1).toString() + '</div><div class="step-name">' + step.name + '</div></div>';
        });

        html += '</div>';
        this.$el.html(html);
    }

    setStep(step) {

    }
};